module.exports = __webpack_public_path__ + "img/affordable-and-clean-energy.de673afa.png";